import styled, { css, keyframes } from 'styled-components';
import { colors } from '../../css';

// Define keyframes for fade animation
const fadeAnimation = keyframes`
  from {
    opacity: 0.6;
  }
  to {
    opacity: 1;
  }
`;

// Styled components
export const SlideShowContainer = styled.div`
  max-width: 1000px;
  position: relative;
  margin: auto;
`;

export const Slide = styled.div`
  display: none;
  animation: ${css`
    ${fadeAnimation} 1.5s
  `};
`;

export const PrevButton = styled.a`
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: ${props => (props.next ? '3px 0 0 3px' : '0 3px 3px 0')};
  user-select: none;
  z-index: 3;
  border-radius: 0 30px 30px 0;

  &:hover {
    background-color: rgba(125, 125, 125, 0.5);
  }
`;

export const NextButton = styled.a`
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: ${props => (props.next ? '3px 0 0 3px' : '0 3px 3px 0')};
  user-select: none;
  z-index: 3;
  border-radius: 30px 0 0 30px;
  right: 0;

  &:hover {
    background-color: rgba(125, 125, 125, 0.5);
  }
`;

export const DotWrapper = styled.div`
  text-align: center;
  margin-top: -30px;
  z-index: 8;
  position: relative;
`;

export const Dot = styled.span`
  cursor: pointer;
  height: 10px;
  width: 10px;
  margin: 0 2px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
  position: relative;

  &.active,
  &:hover {
    background-color: ${colors.colorBlue03};
  }
`;
